import { render, staticRenderFns } from "./fullBodyExamination.vue?vue&type=template&id=b85fa5a8&scoped=true&"
import script from "./fullBodyExamination.vue?vue&type=script&lang=js&"
export * from "./fullBodyExamination.vue?vue&type=script&lang=js&"
import style0 from "./fullBodyExamination.vue?vue&type=style&index=0&id=b85fa5a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85fa5a8",
  null
  
)

export default component.exports